const SHELLY_COTURN: RTCIceServer[] = [
	{
		urls: 'turn:turn.shelly.cloud:3478',
		username: 'admin2',
		credential: 'admin2',
	},
	{
		urls: 'stun:stun.shelly.cloud:3478',
	},
];

export const RTC_CONFIGURATION: RTCConfiguration = {
	iceServers: [...SHELLY_COTURN],
	bundlePolicy: 'max-bundle',
};
export const MAX_POLLS = 10;
export const POLL_DELAY_MS = 350;

/**
 * Supported WebRTC negotiation strategies:
 * - `'GetAnswer'`    — client builds the offer locally and calls
 *                      `Streamer.GetAnswer` to fetch the camera's answer.
 * - `'OfferRequest'` — client calls `streamer.Offer`, the camera returns its
 *                      offer SDP, the client sends back its answer via
 *                      `streamer.Answer`. ICE candidates are optionally
 *                      trickled via `streamer.Trickle` / `streamer.Poll`
 *                      when the offer frame does not include
 *                      `end_of_candidates`.
 */
export type NegotiationStrategy = 'GetAnswer' | 'OfferRequest';

export const NEGOTIATION_STRATEGY: NegotiationStrategy = 'GetAnswer';

export const ICE_GATHERING_TIMEOUT_MS = 2_000;

/**
 * How long the UI waits for the camera to confirm a push-to-talk state change
 * (via the `ptt` data channel) before giving up and forcing the local state
 * to the user's last intent.
 */
export const TALK_CONFIRMATION_TIMEOUT_MS = 10_000;
